import { lazyLoad } from 'utils/loadable';

export const LogHistoryListPage = lazyLoad(
  () => import('./index'),
  module => module.LogHistoryListPage,
);
